import type { AdminContributionGrade } from "@/redux/certifications/types";
import { ALL } from "@/features/certifications/community-flags/constants";
import type {
  QueueVerdict,
  TypeFilter,
  VerdictFilter,
} from "@/features/certifications/community-flags/types";
import { CONTRIBUTION_VERDICTS } from "@/domains/certifications/constants";

export const getQueueVerdict = (grade: AdminContributionGrade): QueueVerdict =>
  grade.aiVerdict === CONTRIBUTION_VERDICTS.OFF_TOPIC
    ? CONTRIBUTION_VERDICTS.OFF_TOPIC
    : CONTRIBUTION_VERDICTS.INCONCLUSIVE;

export const filterGrades = (
  grades: AdminContributionGrade[],
  type: TypeFilter,
  verdict: VerdictFilter = ALL,
) =>
  grades.filter(
    (grade) =>
      (type === ALL || grade.contentKind === type) &&
      (verdict === ALL || getQueueVerdict(grade) === verdict),
  );

export const sortOldestFirst = (grades: AdminContributionGrade[]) =>
  [...grades].sort((a, b) => a.submittedAt.localeCompare(b.submittedAt));

export const sortNewestDecisionFirst = (grades: AdminContributionGrade[]) =>
  [...grades].sort((a, b) =>
    (b.decidedAt ?? b.submittedAt).localeCompare(a.decidedAt ?? a.submittedAt),
  );
